import React from 'react';

function Badge(props) {
    const { label, classNames } = props;
    return (
        <span className={`badge ${classNames}`}>{label}</span>
    )
}

export default Badge